import { Form } from "react-router-dom";
import { useIntl } from "react-intl";
import styles from "./SearchTools.module.scss";
import SearchComboBox from "../../../../common/core-ui/SearchComboBox.tsx";
import { useRef, useState } from "react";
import useTypeahead from "../typeahead/useTypeahead.ts";
import TypeaheadAsset from "../typeahead/TypeaheadAsset.tsx";
import TypeaheadDirectSearch from "../typeahead/TypeaheadDirectSearch.tsx";
import { SearchLink } from "../typeahead/types.ts";

export default function SearchTools({
  query,
  recentSearches,
}: {
  query?: string;
  recentSearches: SearchLink[];
}) {
  const intl = useIntl();
  const formRef = useRef<HTMLFormElement>(null);
  const [value, setValue] = useState(query ?? "");
  const typeaheadMatches = useTypeahead(value);

  return (
    <div className={styles.container}>
      <Form
        method="GET"
        className={styles.form}
        ref={formRef}
        action="/search/titles"
      >
        <SearchComboBox
          noBorder
          onSelectionMade={(index) => {
            if (value === "") {
              recentSearches[index].action();
            } else {
              typeaheadMatches[index].action();
            }
          }}
          placeholder={intl.formatMessage({
            defaultMessage: "Search by ISBN, title, author or publisher...",
          })}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onClear={() => setValue("")}
          name="q"
          inputSize="large"
          listTitle={
            value === ""
              ? intl.formatMessage({ defaultMessage: "Recent Searches" })
              : undefined
          }
          listItems={
            value === ""
              ? recentSearches.map((item) => ({
                  key: item.term,
                  text: item.term,
                }))
              : typeaheadMatches.map((item) => ({
                  key:
                    "asset" in item ? item.asset.manageAsset.vbid : item.type,
                  element:
                    "asset" in item ? (
                      <TypeaheadAsset
                        asset={item.asset.manageAsset}
                        query={item.term}
                        matchType={item.matchType}
                      />
                    ) : (
                      <TypeaheadDirectSearch {...item} />
                    ),
                }))
          }
        />
      </Form>
    </div>
  );
}
